<div class="col-md-12 col-lg-12">
  <div class="col-sm-3"><h4><b>{{ 'pages.createReceiptPage.postalCode' | translate }}</b></h4></div>
  <div *ngIf="!isOpen">
    <div class="col-sm-3"><h4>{{postelCodeText}}</h4></div>
    <div class="col-sm-3"><h4 class="change {{enableChange? '':'disabled'}}" (click)="change()">{{ 'common.change' | translate}}</h4></div>
  </div>
</div>
<div *ngIf="isOpen" >
  <div class="col-md-4 col-sm-10">
    <div class="dropdown {{showDdl ? 'open' : ''}}">
      <div class="inner-addon left-addon">
        <i class="glyphicon armx-search"></i>
        <input type="text" class="form-control" placeholder="search" (keyup)="search($event)" [(ngModel)]="searchTerm" />
      </div>
      <ul class="dropdown-menu">
        <li *ngFor="let item of tempContent; index as i"
            (click)="changeByClick(item)"
            class="{{i==arrowkeyLocation? 'active' :''}}"><a>{{item.CityName}} <i *ngIf="item.StateName!==''">-</i> {{item.StateName}} - {{item.PostCodePrefix}} {{item.PostCodeFrom}}</a></li>
      </ul>
    </div>
  </div>
</div>

